/**
 * User: mphee
 * Date: 12/17/12
 * Time: 8:01 AM
 */
define(function (require) {
  'use strict';
  var $ = require('jquery'),
    _ = require('underscore'),
    Alert = require('common/views/Alert'),
    Backbone = require('backbone'),
    Const = require('common/Const'),
    CommonFunctions = require('common/CommonFunctions'),
    notificationListener = require('common/NotificationListener'),
    LiveReminder = require('common/views/notifications/LiveReminder'),
    ConfirmClass = require('common/views/notifications/ConfirmClass'),
    classTimer = require('common/ClassTimer'),
    NotificationViewer = require('common/views/notifications/NotificationViewer'),
    FeatureNotification = require('common/views/notifications/FeatureNotification'),
    StudyBundleNotification = require('common/views/notifications/StudyBundleNotification'),
    LiveClassFeedbackPopUpNotification = require('common/views/notifications/LiveClassFeedbackPopUpNotification'),
    LiveClassFeedbackModel = require('common/models/LiveClassFeedback');

  return Backbone.View.extend({
    dispatcher: null,
    notificationShowing: false,
    tagName: 'div',
    liveClassReminderShowing: false,

    events: {
      'click a.close': 'onClose',
      'click a.confirm': 'onConfirmMessage',
    },

    closeHandler: function () {
      var me = this;
      notificationListener.deleteNotification(me.notification);

      $('div.banner-notification').fadeOut('slow', 'linear', function () {
        me.handler.remove();
        if (me.html) me.html('');
      });
    },

    initialize: function () {
      var me = this;
      notificationListener.initialize();
    },

    //removes timeOfClass and lateClassTimeout from the localstorage
    cleanUpLateClassTimeout: function () {
      CommonFunctions.removeItemFromLocalStorage('lateClassTimeout');
      CommonFunctions.removeItemFromLocalStorage('timeOfClass');
    },

    //starts a timeout for the given timeOfClass that triggers a new TimesUpDialog
    startLateClassTimer: function (timeOfClass) {
      //always pass in the full date
      var diff = +classTimer.getTimeUntilClassInMs(timeOfClass);

      this.lateClassTimeout = setTimeout(
        _.bind(function () {
          var documentLink = CommonFunctions.getItemFromLocalStorage(
            'documentLink'
          );
          new TimesUpDialog({ documentLink: documentLink });
          this.cleanUpLateClassTimeout();
        }, this),
        diff
      );

      CommonFunctions.setItemIntoLocalStorage(
        'lateClassTimeout',
        this.lateClassTimeout
      );
    },

    //ends the lateClassTimer timeout
    killLateClassTimer: function () {
      clearTimeout(CommonFunctions.getItemFromLocalStorage('lateClassTimeout'));
      this.cleanUpLateClassTimeout();
    },

    start: function () {
      notificationListener.start();
    },

    lookupHandler: function (data) {
      // Temporary measure: don't show popups on mobile
      var isMobile = oeApp.isMobileDevice();
      var isPopupNotification = this._isPopupNotification(data);

      if (isMobile && isPopupNotification) {
        return;
      }

      if (this._isLiveClassReminder(data)) {
        return new LiveReminder({ notification: data });
      } else if (data.type === Const.NOTIFICATION_ENUM.LIVE_STARTING) {
        // Trigger a backbone event, rather than display a notification.
        // Send that notification 'data' as well
        setTimeout(function () {
          Backbone.trigger('liveclass:class-ready', data);
        }, 500);

        // Stop live class polling
        notificationListener.stopLiveClassPolling();

        // This is the on click handler for the join notification
        Backbone.on('notifications:onConfirm', function (notification) {
          window.open(notification.url);
          Backbone.trigger('liveclass:join', notification.scheduleId);
        });

        // Show the join banner notification
        return new NotificationViewer({
          icon: '/images/live-classes-dialogs/join-dialog-img.png',
          buttonText: i18n.studybundle.liveClasses.joinLink,
          title: i18n.studybundle.liveClasses.signUp,
          notificationText: i18n.studybundle.liveClasses.joinMessage,
          notification: data,
        });
      } else if (
        this._isPlacementTestNotification(data) ||
        this._isLevelZeroNotification(data)
      ) {
        return new StudyBundleNotification({ notification: data });
      } else if (this._isFeaturePopUpNotification(data)) {
        return new FeatureNotification({ notification: data });
      } else if (
        (CommonFunctions.isLiveClassFeedback(data) || CommonFunctions.isTeacherFeedbackNotification(data)) 
        && !CommonFunctions.isAskATeacherOrWritingFeedback(data)
      ) {
        CommonFunctions.sendNotificationToAngular(data);
      } else if (CommonFunctions.isAskATeacherOrWritingFeedback(data)) {
        CommonFunctions.sendNotificationToAngular(Object.assign(data, { type: Const.NOTIFICATION_ENUM.GENERIC_POPUP }));
        if (data.personId) {
          notificationListener.confirm(data);
        } else {
          notificationListener.deleteNotification(data);
        }
      } else if (this._isGenericPopUpNotification(data)) {
        CommonFunctions.sendNotificationToAngular(data);
        if (data.personId) {
          notificationListener.confirm(data);
        } else {
          notificationListener.deleteNotification(data);
        }
      } else if (this._isRememberMeLogout(data)) {
        new Alert({
          title: data.title,
          text: data.notification,
          containerClass: 'OE-blue-title',
          buttonClass: 'black-btn',
          onClosed: function () {
            location.reload();
          },
        });
        throw new Error(
          'Suspending all functionality for user session suspension'
        );
      } else if (this._isRejectionNotification(data)) {
        Backbone.trigger('liveclass:class-full', data);

        // Stop polling for live class notifications
        notificationListener.stopLiveClassPolling();

        // Launch the full class banner notification
        return new NotificationViewer({
          icon: '/images/live-classes-dialogs/full-dialog-img.png',
          buttonText: i18n.newLiveClasses.joinClassDialog.noJoinClose,
          title: i18n.LIVE_CLASS_DENIED_TITLE,
          notificationText: i18n.LIVE_CLASS_DENIED,
          notification: data,
        });
      } else if (this._isLiveClassSurvey(data)) {
        CommonFunctions.sendNotificationToAngular(data);
      } else if (this._isGamificationNotification(data)) {
        // send data for modal notification
        window.dispatchEvent(
          new CustomEvent('person-progress-saved', {
            detail: {
              awardedPoints: data.points,
              awardedBadges: data.badges
                ? data.badges.split(',').map(function (e) {
                  return { uuid: e.trim() };
                })
                : null,
              overTheLimitActivity: data.overTheLimitActivity,
              skipSubtle: true,
            },
          })
        );
        notificationListener.deleteNotification(data);
      } else if (
        this._isSuggestedActivitiesNotification(data) ||
        this._isProfileCompletionNotification(data)
      ) {
        notificationListener.confirm(data);
        return;
      } else if (this._isMidLevelNotification(data)) {
        return;
      } else if (this._isNewLevelCongratulatinNotification(data)) {
        CommonFunctions.sendNotificationToAngular(data);
      } else {
        return new NotificationViewer({ notification: data });
      }
    },

    onClose: function (event) {
      if (event) {
        event.preventDefault();
      }
      this.closeHandler();
      return false;
    },

    onConfirmMessage: function (event) {
      event.preventDefault();
      Backbone.trigger('notifications:onConfirm', this.handler.notification);
      this.closeHandler();
    },

    render: function () {
      if ($('#header').length > 0) {
        this.$el.appendTo($('#header'));
      } else if ($('#content').length > 0) {
        this.$el.appendTo($('#content'));
      } else {
        this.$el.appendTo($('body'));
      }

      var me = this;

      Backbone.on('notifications:onNew', _.bind(this.updateNotification, this));
      Backbone.on(
        'notifications:onHide',
        _.bind(this.updateNotification, this)
      );

      Backbone.on('notifications:onHideLiveClassStarting', function (data) {
        if (me.liveClassReminderShowing) {
          me.updateNotification(data);
        }
      });

      return this;
    },

    /**
     * Going to process the 99% case.  Show the first message and after closing show the next.
     *
     *
     * @param data
     */
    updateNotification: function (data) {
      if (this.notificationShowing) {
        if (this.handler) {
          this.handler.remove();
        }
        this.delegateEvents();
      }

      if (
        !data ||
        (data.notifications && data.notifications.length === 0) ||
        data.notiCnt == null
      ) {
        return;
      }

      // Sort notifications by priority
      this.notifications = _.sortBy(data.notifications, function (noti) {
        return noti.priority;
      });

      // Get first study bundle notification & show it
      var notification = this._getFirstNotification(this.notifications);
      if (notification != null) {
        var handler = this.lookupHandler(notification);

        if (handler) {
          handler.render();
          handler.show();
        }
      }

      // Get first live class reminder notification and display it
      // TODO: Is this code deprecated?
      notification = this._getFirstLiveClassReminder(this.notifications);
      if (notification != null) {
        handler = this.lookupHandler(notification);

        if (handler != null) {
          handler.render();
          this.$el.html(handler.$el);
          handler.show();
        }
      }

      // Get first banner notification and display it
      notification = this._getFirstBannerNotification(this.notifications);
      if (notification != null) {
        this.liveClassReminderShowing =
          notification.type === Const.NOTIFICATION_ENUM.LIVE_STARTING;

        this.handler = this.lookupHandler(notification);

        // todo: handle unknown message types
        if (this.handler != null) {
          this.handler.render();
          this.$el.html(this.handler.$el);
          this.handler.show();
          this.notificationShowing = true;
        }
        CommonFunctions.popupDetector(this.$el);

        this.delegateEvents();
      } else {
        this.liveClassReminderShowing = false;
      }

      this.notification = notification;
    },

    _getFirstBannerNotification: function (notifications) {
      var me = this,
        notificationOut = null;
      _.each(notifications, function (notification) {
        if (me._isBannerNotification(notification)) {
          notificationOut = notification;
          return false;
        }
      });

      return notificationOut;
    },

    _getFirstLiveClassReminder: function (notifications) {
      var me = this,
        notificationOut = null;
      _.each(notifications, function (notification) {
        if (me._isLiveClassReminder(notification)) {
          notificationOut = notification;
          return false;
        }
      });

      return notificationOut;
    },

    _getFirstPlacementTestNotification: function (notifications) {
      var me = this,
        notificationOut = null;
      _.each(notifications, function (notification) {
        if (me._isPlacementTestNotification(notification)) {
          notificationOut = notification;
          return false;
        }
      });

      return notificationOut;
    },

    _getLevelZeroNotification: function (notifications) {
      var me = this,
        notificationOut = null;
      _.each(notifications, function (notification) {
        if (me._isLevelZeroNotification(notification)) {
          notificationOut = notification;
          return false;
        }
      });

      return notificationOut;
    },

    _isBannerNotification: function (notification) {
      return (
        !this._isLiveClassReminder(notification) &&
        !this._isPlacementTestNotification(notification) &&
        !this._isLevelZeroNotification(notification)
      );
    },

    _isPopupNotification: function (notification) {
      if(CommonFunctions.isAskATeacherOrWritingFeedback(notification)) {
        return true;
      }
      
      switch (notification.type) {
        case Const.NOTIFICATION_ENUM.GENERIC_POPUP:
        case Const.NOTIFICATION_ENUM.LIVE_SURVEY:
        case Const.NOTIFICATION_ENUM.TEACHER_FEEDBACK:
          return true;
        default:
          return false;
      }
    },

    _isLiveClassReminder: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.LIVE_REMINDER;
    },

    _isPlacementTestNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.PLACEMENT_TEST;
    },

    _isLevelZeroNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.LEVEL_ZERO;
    },

    _isFeaturePopUpNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.FEATURE_POP_UP;
    },

    _isGenericPopUpNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.GENERIC_POPUP;
    },

    _isRejectionNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.LIVE_CLASS_DENIED;
    },

    _isRememberMeLogout: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.REMEMBER_ME_LOGOUT;
    },

    _isLiveClassSurvey: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.LIVE_SURVEY;
    },

    _isSuggestedActivitiesNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.SUGGESTED_ACTIVITIES;
    },

    _isMidLevelNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.MID_LEVEL_TEST;
    },

    _isProfileCompletionNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.PROFILE_COMPLETION;
    },

    _isGamificationNotification: function (notification) {
      return (
        notification.type === Const.NOTIFICATION_ENUM.GAMIFICATION_NOTIFICATION
      );
    },

    _isNewLevelCongratulatinNotification: function (notification) {
      return notification.type === Const.NOTIFICATION_ENUM.NEW_LEVEL_CONGRATULATION;
    },

    _isGlobalNotification: function (notification) {
      return !notification.personId;
    },

    _getFirstNotification: function (notification) {
      var placeNot = this._getFirstPlacementTestNotification(
        this.notifications
      );
      var zeroNot = this._getLevelZeroNotification(this.notifications);

      if (placeNot != null) {
        return placeNot;
      } else {
        if (zeroNot != null) {
          return zeroNot;
        }
      }
      return null;
    },
  });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/SystemMessages.js
// module id = 1057
// module chunks = 26 27 28